import { ENV } from '@environment';
import axios, { AxiosRequestConfig } from 'axios';
import { store } from 'store';

import { /* onUserLogout, */ getRefreshToken } from 'actions/user';
/* import history from 'utils/history'; */

const {
  API: {
    PROFILE: API_PROFILE,
    LOGIN: API_LOGIN,
    RULES: API_RULES,
    TRAVEL: API_TRAVEL,
    USER: API_USER,
    RAPPI_SERVICES: RAPPI_SERVICES,
    RAPPI_SERVICES_CITIES: RAPPI_SERVICES_CITIES,
    COUNTRIES: API_COUNTRIES,
    LOGIN_EXCHANGE: API_LOGIN_EXCHANGE,
    RAPPI_SERVICES_TRAVEL_CITY_SEARCH: RAPPI_TRAVEL_SEARCH_CITIES,
    RAPPI_SERVICES_TRAVEL_HOTEL_SEARCH: RAPPI_TRAVEL_SEARCH_HOTELS,
    RAPPI_SERVICES_TRAVEL_HOTEL_SEARCH_OLD: RAPPI_TRAVEL_SEARCH_HOTELS_OLD,
    RAPPI_SERVICES_TRAVEL_HOTEL_CONTENT: RAPPI_TRAVEL_SEARCH_CONTENT,
    NETACTICA_COUNTRIES: NETACTICA_COUNTRIES_API,
    NETACTICA_PROVINCES: NETACTICA_PROVINCES_API,
    NETACTICA_CITIES: NETACTICA_CITIES_API,
  },
} = ENV;

const axiosConfigDefault = (baseURL?: string) => ({
  baseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export interface CustomRequestConfig extends AxiosRequestConfig {
  noAuth?: boolean;
}

export const rappiServices = axios.create(axiosConfigDefault(RAPPI_SERVICES));
export const rappiServicesCities = axios.create(axiosConfigDefault(RAPPI_SERVICES_CITIES));
export const profile = axios.create(axiosConfigDefault(API_PROFILE));
export const login = axios.create(axiosConfigDefault(API_LOGIN));
export const rules = axios.create(axiosConfigDefault(API_RULES));
export const travel = axios.create(axiosConfigDefault(API_TRAVEL));
export const user = axios.create(axiosConfigDefault(API_USER));
export const countries = axios.create(axiosConfigDefault(API_COUNTRIES));
export const loginExchange = axios.create(axiosConfigDefault(API_LOGIN_EXCHANGE));
export const rappiServicesTravelSearchCities = axios.create(axiosConfigDefault(RAPPI_TRAVEL_SEARCH_CITIES));
export const rappiServicesTravelSearchHotels = axios.create(
  axiosConfigDefault(RAPPI_TRAVEL_SEARCH_HOTELS !== '' ? RAPPI_TRAVEL_SEARCH_HOTELS : RAPPI_TRAVEL_SEARCH_HOTELS_OLD),
);
export const rappiServicesTravelSearchHotelContent = axios.create(axiosConfigDefault(RAPPI_TRAVEL_SEARCH_CONTENT));
export const netaticaCountries = axios.create(axiosConfigDefault(NETACTICA_COUNTRIES_API));
export const netaticaProvinces = axios.create(axiosConfigDefault(NETACTICA_PROVINCES_API));
export const netaticaCities = axios.create(axiosConfigDefault(NETACTICA_CITIES_API));

profile.defaults.params = {};
travel.defaults.params = {};
rules.defaults.params = {};
netaticaCountries.defaults.params = {};
netaticaProvinces.defaults.params = {};
netaticaCities.defaults.params = {};

export const axiosConfig = { data: {} };

const DEFAULT_COUNTRY_CODE = ENV.COUNTRY_CODE.toString() as string;

export const setCompanyId = (companyId: string) => {
  localStorage.setItem('companyIdValue', companyId);
};

export const getCompanyId = () => {
  localStorage.getItem('companyIdValue');
};

export const setAccessToken = (token: string) => {
  localStorage.setItem('token', token);

  let countryCode = localStorage.getItem('country_code');
  const companyId = localStorage.getItem('companyIdValue');

  const params = new URLSearchParams(window.location.search);
  if (!countryCode || params.has('country_code')) {
    countryCode = params.get('country_code') || DEFAULT_COUNTRY_CODE;
    localStorage.setItem('country_code', countryCode);
  }

  const authorizationHeader = {
    Authorization: `Bearer ${token}`,
    CountryCode: countryCode,
  };

  //alert('default.params setToken');
  //alert(profile.defaults.params.companyId);

  rappiServices.defaults.headers.common = authorizationHeader;
  user.defaults.headers.common = authorizationHeader;
  profile.defaults.params.token = token;
  profile.defaults.params.country_code = countryCode;
  profile.defaults.params.companyId = companyId;

  travel.defaults.params.token = token;
  travel.defaults.params.country_code = countryCode;
  travel.defaults.params.companyId = companyId;

  rules.defaults.params.token = token;
  rules.defaults.params.country_code = countryCode;
  rules.defaults.params.companyId = companyId;
  
  netaticaCountries.defaults.params.token = token;
  netaticaProvinces.defaults.params.token = token;
  netaticaCities.defaults.params.token = token;
  
};

export const setResellerParams = (countryCode: string, companyId: string) => {
  let countryCodeValue = '57';

  switch (countryCode?.toUpperCase()) {
    case 'CO': {
      countryCodeValue = '57';
      break;
    }
    case 'BR': {
      countryCodeValue = '55';
      break;
    }
    case 'AR': {
      countryCodeValue = '54';
      break;
    }
    case 'MX': {
      countryCodeValue = '52';
      break;
    }
    case 'CL': {
      countryCodeValue = '56';
      break;
    }
    case 'PE': {
      countryCodeValue = '51';
      break;
    }
  }

  localStorage.setItem('country_code', countryCodeValue);
  localStorage.setItem('companyIdValue', companyId);
  //Update el interceptor del ms-profile
  profile.defaults.params.country_code = countryCodeValue;
  profile.defaults.params.companyId = companyId;

  profile.interceptors.request.use(
    (config: CustomRequestConfig) => {
      handleRefreshToken(config);
      return {
        ...setAcceptHeader(config),
        params: {
          ...profile.defaults.params,
          ...config.params,
          token: config.noAuth ? '' : profile.defaults.params.token,
        },
      };
    },
    (error) => Promise.reject(error),
  );

  //Update el interceptor del ms-travel
  travel.defaults.params.country_code = countryCodeValue;
  travel.defaults.params.companyId = companyId;

  travel.interceptors.request.use(
    (config: CustomRequestConfig) => {
      handleRefreshToken(config);
      return {
        ...setAcceptHeader(config),
        params: {
          ...travel.defaults.params,
          ...config.params,
          token: config.noAuth ? '' : travel.defaults.params.token,
        },
      };
    },
    (error) => Promise.reject(error),
  );

  //Update el interceptor del ms-rules-engine
  rules.defaults.params.country_code = countryCodeValue;
  rules.defaults.params.companyId = companyId;

  rules.interceptors.request.use(
    (config: CustomRequestConfig) => {
      handleRefreshToken(config);
      return {
        ...setAcceptHeader(config),
        params: {
          ...rules.defaults.params,
          ...config.params,
          token: config.noAuth ? '' : rules.defaults.params.token,
        },
      };
    },
    (error) => Promise.reject(error),
  );
};

const localStorageToken = localStorage.getItem('token');
if (localStorageToken) setAccessToken(localStorageToken);

const handleGetDate = (expiresIn: number) => {
  const dateNow = new Date().getMinutes();
  return dateNow + expiresIn;
};

const handleRefreshToken = (config: AxiosRequestConfig) => {
  const { dispatch } = store;
  const storeExpiresIn = store.getState().user.userResult?.expiresIn;
  const storeRefreshToken = store.getState().user.userResult?.refreshToken;

  if (storeExpiresIn && storeRefreshToken) {
    if (handleGetDate(storeExpiresIn) === 0) {
      dispatch(getRefreshToken(storeRefreshToken));
    }
    return config;
  }
};

const setAcceptHeader = (config: AxiosRequestConfig) => {
  const currentLanguage = sessionStorage.getItem('@currentLanguage') || store.getState().i18n.country.culture;
  config.headers.common = {
    ...config.headers.common,
    'Accept-Language': currentLanguage.startsWith('es') ? 'es' : currentLanguage,
  };
  return config;
};

rappiServices.interceptors.request.use((config: CustomRequestConfig) => ({
  ...setAcceptHeader(config),
  headers: {
    ...config.headers,
    Authorization: config.noAuth ? '' : config.headers.Authorization || config.headers.common.Authorization,
  },
}));
rappiServicesCities.interceptors.request.use((config) => setAcceptHeader(config));

travel.interceptors.request.use(
  (config: CustomRequestConfig) => {
    handleRefreshToken(config);
    return {
      ...setAcceptHeader(config),
      params: {
        ...travel.defaults.params,
        ...config.params,
        token: config.noAuth ? '' : travel.defaults.params.token,
      },
    };
  },
  (error) => Promise.reject(error),
);

rules.interceptors.request.use(
  (config: CustomRequestConfig) => {
    handleRefreshToken(config);
    return {
      ...setAcceptHeader(config),
      params: {
        ...rules.defaults.params,
        ...config.params,
        token: config.noAuth ? '' : rules.defaults.params.token,
      },
    };
  },
  (error) => Promise.reject(error),
);

profile.interceptors.request.use(
  (config: CustomRequestConfig) => {
    handleRefreshToken(config);
    return {
      ...setAcceptHeader(config),
      params: {
        ...profile.defaults.params,
        ...config.params,
        token: config.noAuth ? '' : profile.defaults.params.token,
      },
    };
  },
  (error) => Promise.reject(error),
);

/* profile.interceptors.response.use(
  (config) => {
    handleRefreshToken(config);
    return config;
  },
  (error) => {
    const { dispatch } = store;
    const status = error.status || error.response ? error.response.status : 400;

    if (status === 403 || status === 401) {
      dispatch(onUserLogout()).then(() => history.push('/corporate/login'));
    }
    return Promise.reject(error);
  },
); */

rappiServicesTravelSearchCities.interceptors.request.use((config) => setAcceptHeader(config));
rappiServicesTravelSearchHotels.interceptors.request.use((config) => setAcceptHeader(config));
rappiServicesTravelSearchHotelContent.interceptors.request.use((config) => setAcceptHeader(config));
netaticaCities.interceptors.request.use((config) => setAcceptHeader(config));
netaticaCountries.interceptors.request.use((config) => setAcceptHeader(config));
netaticaProvinces.interceptors.request.use((config) => setAcceptHeader(config));
